import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[320px] lg:max-w-[400px]">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={appData.image}
                alt="8848影院多端观影"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-4">{appData.title}</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 whitespace-pre-line">
              {appData.description}
            </p>

            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              {appData.features.map((f) => (
                <span
                  key={f}
                  className="whitespace-nowrap px-4 py-2 rounded-full bg-background-50 border border-background-200/60 text-sm text-foreground-700 font-medium"
                >
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}